import React, { useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "components/common/Button/CustomButton";
import ConfirmationModal from "components/common/Modal/ConfirmationModal";

const FormBuilderDiscardButton = ({
  hasChanges = false,
  onDiscard,
  label = "Discard changes",
  isDisabled = false,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleDiscard = () => {
    onDiscard?.();
    setShowModal(false);
    toast.info("Unsaved changes were discarded.");
  };

  return (
    <>
      <CustomButton
        type='button'
        variant='danger'
        cssClass='form-btn-cancel form-btn-discard'
        label={label}
        isDisabled={!hasChanges || isDisabled}
        clickHandler={() => setShowModal(true)}
      />

      <ConfirmationModal
        isNew
        showModal={showModal}
        title='Discard unsaved changes?'
        cancelBtnLabel='Keep editing'
        confirmBtnLabel='Discard changes'
        variantConfirmBtn='danger'
        closeModalHandler={() => setShowModal(false)}
        submitHandler={handleDiscard}
        modalCssClass='w-[92%] max-w-lg sm:max-w-xl z-[99999]'
      >
        <div className='space-y-3 text-sm leading-relaxed text-gray-700'>
          <p>
            This will restore the form to how it was when you opened it or last
            saved. Any edits, imported PDF fields, and unsaved title or category
            changes will be removed.
          </p>
          <p className='text-gray-500'>
            This cannot be undone. Save as draft first if you want to keep the
            current version.
          </p>
        </div>
      </ConfirmationModal>
    </>
  );
};

export default FormBuilderDiscardButton;
